// Autogenerated file
import header from './header';

export default {
  ...header,
};
